import BackButton from "@dashboard/components/BackButton";
import { ConfirmButton, ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import { DashboardModal } from "@dashboard/components/Modal";
import { buttonMessages } from "@dashboard/intl";
import { Box, Checkbox, Input, Text } from "@saleor/macaw-ui-next";
import { FC, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { messages } from "../NewsletterListPage/messages";

interface AddRecipientDialogProps {
  open: boolean;
  confirmButtonState: ConfirmButtonTransitionState;
  onClose: () => void;
  onSubmit: (data: { email: string; active: boolean }) => void;
}

export const AddRecipientDialog: FC<AddRecipientDialogProps> = ({
  open,
  confirmButtonState,
  onClose,
  onSubmit,
}) => {
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (open) {
      setEmail("");
      setActive(true);
    }
  }, [open]);

  return (
    <DashboardModal onChange={onClose} open={open}>
      <DashboardModal.Content size="sm">
        <DashboardModal.Header>
          <FormattedMessage {...messages.addRecipientTitle} />
        </DashboardModal.Header>
        <Box display="flex" flexDirection="column" gap={4}>
          <Input
            label={intl.formatMessage(messages.emailLabel)}
            type="email"
            value={email}
            onChange={event => setEmail(event.target.value)}
            data-test-id="recipient-email-input"
          />
          <Box display="flex" alignItems="center" gap={2}>
            <Checkbox
              checked={active}
              onCheckedChange={value => setActive(value === true)}
              data-test-id="recipient-active-checkbox"
            />
            <Text>
              <FormattedMessage {...messages.activeLabel} />
            </Text>
          </Box>
        </Box>
        <DashboardModal.Actions>
          <BackButton onClick={onClose} />
          <ConfirmButton
            transitionState={confirmButtonState}
            disabled={!email.trim()}
            onClick={() => onSubmit({ email: email.trim(), active })}
            data-test-id="submit"
          >
            <FormattedMessage {...buttonMessages.add} />
          </ConfirmButton>
        </DashboardModal.Actions>
      </DashboardModal.Content>
    </DashboardModal>
  );
};
